<template>
  <div id="app">
    <Home />
  </div>
</template>

<script>
import Home from './components/Home.vue'

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

section {
  scroll-margin-top: 80px; /* Adjust based on your navbar height */
  transition: all 0.5s ease;
}

.highlight-section {
  animation: highlight-animation 1s ease;
}

@keyframes highlight-animation {
  0% {
    box-shadow: 0 0 0 0 rgba(209, 192, 110, 0);
  }
  25% {
    box-shadow: 0 0 50px 10px rgba(209, 192, 110, 0.3);
  }
  75% {
    box-shadow: 0 0 50px 10px rgba(209, 192, 110, 0.3);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(209, 192, 110, 0);
  }
}

#app {
  width: 100%;
  overflow-x: hidden;
}
</style>

